import React, { useState, useEffect } from "react";
import GoogleMapReact from 'google-map-react';

// Marker component to show the custom marker (using an image)
const Marker = ({ lat, lng, text, icon }) => (
  <div style={{ position: 'absolute', transform: 'translate(-50%, -50%)' }}>
    <img src={icon} alt="marker" style={{ width: '30px', height: '30px' }} />
    <div style={{ color: 'red', fontSize: '14px', marginTop: '5px' }}>
      <strong>{text}</strong>
    </div>
  </div>
);

const UserLocationMap = ({ data }) => {
  // Check if 'data' is an array before destructuring
  const [latitude, longitude] = Array.isArray(data) && data.length === 2 ? data : [59.95, 30.33]; // Default location if data is invalid
  
  const [latLng, setLatLng] = useState({
    lat: longitude,
    lng: latitude,
  });

  const redMarkerIcon = "https://i.imghippo.com/files/PT2929rs.png";

  console.log("latLng:", latLng);

  return (
    <div style={{ height: '300px', width: '100%' }}>
      <GoogleMapReact
        bootstrapURLKeys={{ key: 'AIzaSyBbvuzwkAMflFBj3Po5oybfHCAjejwj6ww' }} // Replace with your API key
        center={latLng} // Use latLng from state
        zoom={11}
      >
        {/* Marker component with latitude and longitude from latLng state */}
        <Marker 
          lat={latLng.lat} 
          lng={latLng.lng} 
          icon={redMarkerIcon} 
        />
      </GoogleMapReact>
    </div>
  );
};

export default UserLocationMap;
